import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledPointsWrapper = styled.div`
  .pointswrapper {
    padding: ${toRem(32)} 0;

    @media ${baseVariables.mediaQuery.md} {
      padding: ${toRem(48)} 0;
    }

    &__intro {
      max-width: ${toRem(720)};
    }

    &__grid {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: ${toRem(24)};
      align-items: start;

      @media ${baseVariables.mediaQuery.md} {
        grid-template-columns: 1fr;
      }

      @media ${baseVariables.mediaQuery.lg} {
        grid-template-columns: 1fr 2fr;
      }
    }

    &__header,
    &__description,
    &__list {
      color: ${baseVariables.color.base10};
    }

    &__list {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    &__item {
      border-top: ${toRem(1)} solid ${baseVariables.color.neutral30};
      padding: ${toRem(13)} 0;
    }

    &__item-icon {
      gap: ${toRem(16)};
      > span:first-child {
        width: ${toRem(24)};
        height: ${toRem(24)};
        .icon {
          font-size: ${toRem(24)};
        }
      }
    }

    &__cards {
      display: grid;
      grid-template-columns: 1fr;
      gap: ${toRem(24)};
      align-items: stretch;
    }

    &__card .card-vertical > * {
      width: 100%;
      background-color: ${baseVariables.color.base20};
    }

    &__card .card-vertical_heading {
      margin: 0;
      line-height: 125%;
      font-size: ${toRem(22)};
      padding-bottom: ${toRem(4)};
    }

    &__card .card-vertical_chevron {
      height: 100%;
    }

    &__card .card-vertical_description {
      -webkit-line-clamp: 2 !important;
      line-height: 150%;
    }

    @media ${baseVariables.mediaQuery.md} {
      &__list-col {
        margin-bottom: 0;
      }
      &__cards {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }
`;
